<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="_toc" id="_idParaDest-2">Contents<a id="_idTextAnchor000"></a></p>
<p class="toc-ch ParaOverride-1"><a href="#/Intro#_idTextAnchor001">Introduction</a></p>
<p class="toc-ch ParaOverride-2"><a href="#/1Herbs#_idTextAnchor002">Herbs</a></p>
<p class="toc-ch ParaOverride-2"><span href="#/2Stones#_idTextAnchor004" title="Link target outside of Sample">Stones</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/3Candles#_idTextAnchor005" title="Link target outside of Sample">Candles</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/4MagRec#_idTextAnchor006" title="Link target outside of Sample">Magical Recipes</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/5Div#_idTextAnchor007" title="Link target outside of Sample">Divination</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/6Gods#_idTextAnchor008" title="Link target outside of Sample">Gods and Goddesses</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/7Invocations#_idTextAnchor009" title="Link target outside of Sample">Invocations and <br/>Quarter Calls</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/8Spells#_idTextAnchor010" title="Link target outside of Sample">Spells</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/9Rituals#_idTextAnchor011" title="Link target outside of Sample">Rituals</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/10Recipes#_idTextAnchor012" title="Link target outside of Sample">Recipes</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/11Corres#_idTextAnchor013" title="Link target outside of Sample">Correspondences</span></p>
<p class="toc-ch ParaOverride-2"><span href="#/12About#_idTextAnchor014" title="Link target outside of Sample">About the Artist</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?9d2c934e